import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IJbpGlobalPartnerPartnersContact } from '../models/jbpGlobalPartnerPartnersContact'

export const getJbpGlobalPartnerPartnersContactsCrud = () => {
  return CrudStore.get(
    CrudStoreItemPartner360.JBPGlobalPartnerPartnersContacts,
    'globalPartnerContacts'
  ) as Crud<IJbpGlobalPartnerPartnersContact>
}
